// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { oneTrustStyles } from "@rc/App/Components/OneTrust/OneTrust";
import { xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

oneTrustStyles.container = {
    css: css`
        padding: 8px 0;
        position: absolute;
        &.top_right {
            top: 170px;
            right: 180px;
            ${xScreen("lte", 1024)} {
                top: 120px;
            }
        }
        &.top_left {
            top: 170px;
            left: 0;
            ${xScreen("lte", 1024)} {
                top: 120px;
            }
        }
        &.bottom_right {
            bottom: 70px;
            right: 150px;
            ${xScreen("lte", "sm")} {
                bottom: 110px;
            }
        }
        &.bottom_left {
            bottom: 70px;
            left: 0;
            ${xScreen("lte", "sm")} {
                bottom: 110px;
            }
        }
        .one-trust {
            position: absolute;
            z-index: 9999;
            min-width: 150px;
        }
        .optanon-show-settings-popup-wrapper {
            position: absolute;
            z-index: 10;

            @media print {
                display: none !important;
            }

            div.optanon-show-settings-middle {
                height: rem-calc(30) !important;
            }
        }
        #optanon-cookie-policy {
            // displayed none in classic
            display: none;
            .optanon-cookie-policy-group-name {
                font-size: rem-calc(30);
                font-weight: 300;
                color: #e2001a;
                line-height: 1.875rem;
                margin-bottom: rem-calc(25);
            }

            ul.optanon-cookie-policy-group-cookies-list {
                list-style: none;
                padding-left: rem-calc(20);
                margin-bottom: rem-calc(40);

                li a {
                    color: #666;
                    border-bottom-color: #767676;
                    font-size: rem-calc(16);
                    font-weight: 500;
                    line-height: rem-calc(14.4);
                }
            }

            .optanon-cookie-policy-subgroup-name a {
                color: #666;
                border-bottom-color: #767676;
                font-size: rem-calc(16);
                font-weight: 500;
                line-height: rem-calc(14.4);
            }

            .optanon-cookie-policy-right {
                padding-left: rem-calc(30) !important;

                ul.optanon-cookie-policy-subgroup-cookies-list {
                    list-style: none;
                    padding: 0;
                    text-align: left;
                }
            }

            .optanon-cookie-policy-subgroup-table {
                margin-bottom: rem-calc(40);

                tr {
                    background-color: #fff;
                }

                th {
                    font-weight: 700 !important;
                }

                th,
                td {
                    border: rem-calc(1) solid #d7d7d7;

                    p,
                    ul {
                        margin: 0;
                    }
                }
            }
        }
        .banner-policy-link {
            color: #fff;
            margin-left: 0.5em;
        }
    `,
};

oneTrustStyles.cookiesButton = {
    variant: "secondary",
    css: css`
        &&& {
            border-radius: 0;
            font-size: 0.8em;
            padding: 0.8em 2em;
            line-height: 1.2;
        }
    `,
};
